import type { NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Router middleware for auth guard
 */
export const authGuard: NavigationGuard = async (to) => {
   const authStore = useAuthStore();

   /*
    * Initialize the auth store, fetch and get user info
    */
   if (!authStore.isInitialized) {
      await authStore.init();
   }

   // helmsdeep (ENG-347): all interactive auth is brokered by the hub.
   const { redirectToHub } = await import('@/auth/hub.ts');

   // The in-app login page is retired under the hub. Anyone landing on /login —
   // e.g. a bookmark — is redirected: signed-in users to the app root, everyone
   // else to the hub. (redirectToHub's return is /auth/callback, which routes on
   // to /, so this never loops back to the login page.) NMED users are served
   // NMED branding at /login by host, so there is no separate /nmed-login route
   // to special-case here.
   if (to.path === '/login') {
      if (authStore.isAuthenticated) {
         return '/';
      }
      redirectToHub();
      return false;
   }

   if (to.meta.requiresAuth && !authStore.isAuthenticated) {
      redirectToHub();
      return false;
   }
};
